import React, { useRef, useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { showLandingPage } from "../../../../redux/features/authSlice";
import { dismissModal } from "../../../../redux/features/modalSlice";
import GuessButton from "../../../ActionPanel/GuessButton";
import logo from "../../../../Assets/newsie-triumphant-192-removebg.png"; // Tell webpack this JS file uses this image

import LeaderBoard from "../../modals/HamburgerMenu/pages/Default/LeaderBoard";
import IncorrectGuesses from "../../../ActionPanel/GameDetails/IncorrectGuesses";
import Stopwatch from "../../../ActionPanel/GameDetails/Stopwatch";

import "./Winner.css";
import PerformanceUpdate from "./PerformanceUpdate";
import WinnerSubscribe from "./WinnerSubscribe";
import Score from "../../../ActionPanel/GameDetails/Score";
import Confetti from "react-confetti";
import { generateShareCardBlob } from "../../../../util/shareCard";
import { EMOJI_CATEGORY_TITLES, NEWSIE_CATEGORIES, SHOW_TOPIC_PUZZLES } from "../../../../util/constants";
const Winner = () => {
  const dispatch = useDispatch();
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [left, setLeft] = useState(0);
  const [shareImageBlob, setShareImageBlob] = useState<Blob | null>(null);

  const ref = useRef(null);
  const pageContainerRef = useRef(null);

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientHeight + 30);
      setWidth(ref.current.clientWidth);
    }
    if (pageContainerRef.current) {
      console.log(pageContainerRef.current.getBoundingClientRect());
      setLeft(pageContainerRef.current.getBoundingClientRect().left);
    }
  }, [ref.current, pageContainerRef.current]);

  const selectedNewsie = useSelector(
    (state: any) => state.gameReducer.selectedNewsie
  );
  // Topic games (sports etc.) don't count toward streaks or the leaderboard
  const isTopicGame = selectedNewsie !== NEWSIE_CATEGORIES[0];
  const promoUrl = useSelector((state: any) => state.gameReducer.promoUrl);
  const dailyTopScores = useSelector(
    (state: any) => state.metaReducer.dailyTopScores
  );

  const timer = useSelector((state: any) => state.gameReducer.timer[selectedNewsie]);

  const username = useSelector((state: any) => state.profileReducer.username);
  const isLoggedIn = useSelector((state: any) => Boolean(state.authReducer.authToken));
  const incorrectGuesses = useSelector(
    (state: any) => state.gameReducer.incorrectGuesses[selectedNewsie]
  );
  const { time, timer_active } = useSelector((state: any) =>
    state.gameReducer.timer && state.gameReducer.timer[selectedNewsie]
      ? state.gameReducer.timer[selectedNewsie]
      : { time: -1, timer_active: false }
  );
  const SCORE = 1000 - time - 10 * incorrectGuesses;

  const guessSequence = useSelector(
    (state: any) => state.gameReducer.guessSequence?.[selectedNewsie] || []
  );
  const lastNewsieUpdateDate = useSelector(
    (state: any) => state.gameReducer.lastNewsieUpdateDate
  );
  const performanceUpdateStreak = useSelector(
    (state: any) => state.gameReducer.performanceUpdate?.currentStreak
  );
  const persistedStreak = useSelector(
    (state: any) => state.userPerformanceReducer.currentStreak
  );
  const streak = performanceUpdateStreak || persistedStreak;

  useEffect(() => {
    generateShareCardBlob({
      won: true,
      score: SCORE,
      incorrectGuesses,
      category: selectedNewsie,
      date: lastNewsieUpdateDate,
      guessSequence,
      streak,
    }).then(setShareImageBlob).catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={pageContainerRef} className="winner-modal">
      <div style={{ width: "100%" }} ref={ref}>
        <div className="confetti-container" style={{ left: "100px" }}>
          <Confetti
            width={width - 200}
            height={height}
            opacity={0.4}
            initialVelocityY={5}
            recycle={true}
            gravity={0.05}
          />
        </div>

        <div className="winner-modal-header-text-container">
          <h4>WOO HOO!</h4>
          <div className="username-or-username-cta-container">
            {username ? (
              <div className="username"> {username}</div>
            ) : (
              <div className="set-username-cta">Set your username!</div>
            )}
          </div>
          <h4>
            {isTopicGame
              ? `You won today's ${EMOJI_CATEGORY_TITLES[selectedNewsie]?.[0] || ""} newsie!`
              : "You won today's newsie!"}
          </h4>
        </div>
        <div className="winner-modal-mr-newsie">
          <img src={logo} alt="Logo" />
        </div>
      </div>

      <div className="completed-game-final-details-container">
        <div className="completed-time-container">
          <Stopwatch />
        </div>
        <IncorrectGuesses incorrectGuesses={incorrectGuesses} />
        <Score score={SCORE} />
      </div>
      {!isLoggedIn && <WinnerSubscribe />}
      {!isTopicGame && <PerformanceUpdate />}
      {promoUrl ? (
        <div className="cash-drop-container">
          <a href={promoUrl} onClick={(e) => e.stopPropagation()}>
            💰 Cash drop!
          </a>
          <div>
            If you're the first to find the cash, its yours! Good luck!
          </div>
        </div>
      ) : null}
      <div className="title-description-divider" />
      {!isTopicGame && (
        <LeaderBoard
          leaderBoardTitle="Today's Top Scores"
          leaderBoardData={dailyTopScores}
        />
      )}
      {SHOW_TOPIC_PUZZLES && (
      <button
        className="winner-more-puzzles-button"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(dismissModal());
          dispatch(showLandingPage());
        }}
      >
        Play another topic →
      </button>
      )}
      <div className="share-button-wrapper">
        <GuessButton
          modal
          gameOver={true}
          guessable={true}
          won={true}
          time={timer?.time}
          score={SCORE}
          incorrectGuesses={incorrectGuesses}
          shareImageBlob={shareImageBlob}
        />
      </div>
    </div>
  );
};

export default Winner;
